import { ReactNode } from 'react';
import CustomButton from '../reusable/CustomButton';
import CustomModal from '../reusable/CustomModal';

import './TranscriptSelectionWarningModal.css';

export interface TranscriptReviewModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  type: 'approve' | 'reject' | 'reopen';
  isLoading?: boolean;
  customMessage?: ReactNode;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

const TranscriptReviewModal = ({
  isOpen,
  handleClose,
  handleConfirm,
  type,
  isLoading = false,
  customMessage,
  confirmButtonText,
  cancelButtonText,
}: TranscriptReviewModalProps) => {
  const getActionText = () => {
    switch (type) {
      case 'approve':
        return 'approving';
      case 'reject':
        return 'rejecting';
      case 'reopen':
        return 're-opening transcript selection';
      default:
        return '';
    }
  };

  const actionText = getActionText();
  const message = customMessage || (
    <>
      By confirming, you are <b>{actionText}</b>
      {type !== 'reopen' && ' the transcript selection'}.
    </>
  );

  return (
    <>
      {isOpen && (
        <CustomModal title="Are you sure?" isOpen={isOpen} handleClose={handleClose} icon={false}>
          <p>{message}</p>
          <div className="custom-modal-actions-container">
            <CustomButton
              variant="secondary"
              buttonText={cancelButtonText || 'Cancel'}
              buttonAction={handleClose}
              disabled={isLoading}
            />
            <CustomButton
              variant="primary"
              buttonText={confirmButtonText || 'Confirm'}
              buttonAction={handleConfirm}
              disabled={isLoading}
            />
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default TranscriptReviewModal;
